import type { CityConfig } from "@/pages/city-template/types";

export const troyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Troy",
  state: "New York",
  stateAbbr: "NY",
  slug: "troy",
  route: "/troy",
  title: "Emergency Passport Troy, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Troy, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving RPI engineering students, Hudson River professionals, Capital Region families, and all Rensselaer County travelers.",
  h1: "Emergency & Expedited Passport Services in Troy, NY",
  heroSubtitle: "RPI engineering co-op in Germany starts in 10 days and your passport just expired? Amtrak to JFK for a London flight this weekend and you just discovered the issue? Hudson River family heritage trip to Italy booked for next month? We help Troy residents — from RPI students on campus to downtown professionals to Brunswick families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Troy%20New%20York%20skyline%20along%20the%20Hudson%20River%20with%20historic%2019th%20century%20brick%20architecture%20and%20RPI%20campus%20on%20the%20hill%2C%20the%20iconic%20Rice%20Building%20and%20Troy%20Savings%20Bank%20Music%20Hall%20visible%2C%20warm%20golden%20hour%20sunlight%20casting%20dramatic%20shadows%20across%20the%20historic%20downtown%20streets%2C%20modern%20travel%20photography%20with%20rich%20warm%20tones%20and%20crisp%20detail%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=troy-hero-2026&orientation=landscape",
  heroImageAlt: "Troy New York skyline along the Hudson River with historic architecture and RPI campus at golden hour",
  geoPosition: "42.7284;-73.6918",
  geoPlacename: "Troy, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Approximately 150 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Rensselaer", zips: "12144" },
    { name: "East Greenbush", zips: "12061, 12144" },
    { name: "Watervliet", zips: "12189" },
    { name: "Cohoes", zips: "12047" },
    { name: "Brunswick", zips: "12180" },
    { name: "Schodack", zips: "12063" },
    { name: "North Greenbush", zips: "12180, 12144" },
    { name: "Albany", zips: "12201–12288" },
    { name: "Schenectady", zips: "12301–12309, 12325, 12345" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Utica", zips: "13501–13599" },
    { name: "Syracuse", zips: "13201–13290" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Capital Region Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Troy-area travelers with immediate departures from ALB or JFK." },
    { icon: "ri-flight-takeoff-line", title: "ALB & Amtrak Corridor Expertise", desc: "Albany International is 15 minutes away and Troy Amtrak Station connects to JFK in 3 hours. We know Capital Region airline schedules and Amtrak connection dynamics." },
    { icon: "ri-graduation-cap-line", title: "RPI Engineering Study Abroad Ready", desc: "Rensselaer Polytechnic Institute sends engineering students abroad for co-ops, research, and exchange programs across Germany, Switzerland, Singapore, and beyond — we handle the compressed academic timelines." },
    { icon: "ri-building-2-line", title: "Collar City Heritage + Capital Region Corporate", desc: "From Troy's historic industrial waterfront to the Capital Region's growing tech corridor — we serve families, engineers, and professionals across Rensselaer County." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albany, NY", route: "/albany-ny" },
    { name: "Expedited passport in Schenectady, NY", route: "/schenectady" },
    { name: "Quick passport services in Saratoga Springs, NY", route: "/saratoga-springs" },
    { name: "Urgent passport services in Syracuse, NY", route: "/syracuse" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Troy via secure registered courier with direct access to the New York Passport Agency in Manhattan. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait or the 3-hour drive south. Troy residents can ship from any UPS Store, FedEx Office, or post office location across Rensselaer County.",
  fpcOfficeDistance: "Serving Troy, Rensselaer, East Greenbush, Brunswick, and all Capital Region communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Troy and the greater Capital Region. From the historic downtown along the Hudson River to the RPI campus on the hill, from Rensselaer to East Greenbush — we serve all of Rensselaer County. Our courier service eliminates the need to drive to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Troy and all Capital Region communities including Rensselaer, East Greenbush, Watervliet, Cohoes, and Brunswick. We also serve travelers departing from Albany International Airport (ALB) and Troy Amtrak Station who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Troy as simple as possible — with the efficiency and reliability RPI students, Capital Region professionals, and Rensselaer County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Troy travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Troy travelers encounter unique passport issues — everything from RPI co-op acceptance-to-departure windows to Amtrak-to-JFK connection passport requirements to Italian and Irish heritage travel with 6-month validity rules. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Troy travelers — from RPI engineering students to downtown professionals to Brunswick families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Troy, NY? Here are the most common ones we hear from Capital Region travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a RPI co-op in Germany, an emergency passport for a last-minute Amtrak-to-JFK connection, or a first-time passport for a Collar City family heritage trip to Italy — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Must drive 3+ hours to Manhattan", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "RPI co-op starting in Germany next week? Family emergency overseas? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Troy-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Troy residents renew fast — no agency visit required for most renewals. Perfect for RPI faculty, Capital Region professionals, and Rensselaer County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Troy residents through every step — from downtown to Rensselaer to Brunswick — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your RPI co-op or Capital Region business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip to Italy or your first international vacation stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Troy professionals after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for RPI researchers with overlapping visa applications, engineering co-op students, and Troy professionals traveling internationally on short notice.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Capital Region travelers through the process so your international itinerary or corporate travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Capital Region residents making weekend Montreal or Toronto trips.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Troy NY", description: "Urgent passport processing for Troy New York travelers with immediate departure needs from Albany International Airport or Amtrak." },
    { name: "Expedited Passport Renewal Troy NY", description: "Fast passport renewal for Troy New York residents with a previously-issued passport." },
    { name: "First-Time Passport Troy NY", description: "New passport application services for Troy New York residents applying for their first passport." },
    { name: "Child Passport Troy NY", description: "Minor passport services for Troy New York families with children under 16." },
    { name: "Name Change Passport Troy NY", description: "Passport name correction after marriage, divorce, or legal name changes for Troy residents." },
    { name: "Second Passport Troy NY", description: "Second passport services for RPI researchers and Capital Region frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Alex K.",
      location: "RPI Campus, Troy",
      rating: 5,
      text: "Got accepted to a co-op in Stuttgart with 2 weeks notice and my passport was expired. Fast Passport Center renewed it in 3 days. The agent knew exactly what RPI engineering students need for international co-ops — saved my semester.",
      service: "Passport Renewal",
    },
    {
      name: "Maria C.",
      location: "Downtown Troy",
      rating: 5,
      text: "We took Amtrak to JFK for a flight to Rome and discovered our daughter's passport was expired at the station. Fast Passport Center processed a new child passport in 4 days. We rebooked the flight and made it with time to spare.",
      service: "Child Passport",
    },
    {
      name: "Kevin M.",
      location: "Brunswick, NY",
      rating: 5,
      text: "I work for a Capital Region tech company and needed a second passport while my primary was in visa processing for India. Fast Passport Center understood the timeline and had it in 5 days. Invaluable service.",
      service: "Second Passport",
    },
    {
      name: "Diana R.",
      location: "East Greenbush, NY",
      rating: 5,
      text: "Family heritage trip to Ireland — 3 of our 4 passports were expired. Fast Passport Center handled all three renewals and got them back in 5 days. The document review caught a photo issue on mine that would have caused a rejection.",
      service: "Family Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "troy-1",
      name: "Troy Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 Broadway",
      city: "Troy",
      state: "NY",
      zip: "12180",
      phone: "(518) 274-0350",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Troy passport acceptance facility in the historic downtown. First-time applicants must apply in person. Photo services on-site. Saturday hours are popular — book early during RPI semester transitions.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-2",
      name: "Rensselaer Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 Broadway",
      city: "Rensselaer",
      state: "NY",
      zip: "12144",
      phone: "(518) 465-0621",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rensselaer — across the Hudson River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Rensselaer and east-of-the-river residents. Less crowded than Troy Main — often faster appointment availability. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-3",
      name: "Wynantskill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2900 Pawling Avenue",
      city: "Wynantskill",
      state: "NY",
      zip: "12198",
      phone: "(518) 283-4215",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Wynantskill — east Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wynantskill, North Greenbush, and east Troy communities. Smaller facility with shorter wait times — great alternative during RPI move-in weeks.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-4",
      name: "RPI — International Services Office",
      type: "Campus Passport Guidance",
      address: "110 8th Street, Academy Hall",
      city: "Troy",
      state: "NY",
      zip: "12180",
      phone: "(518) 276-6000",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (academic year)",
      distance: "RPI Campus — downtown Troy",
      website: "https://info.rpi.edu/international-services",
      websiteLabel: "RPI International Services",
      notes: "Campus resource for RPI students and faculty needing passport guidance for study abroad and international co-ops. Not a full passport acceptance facility — students directed to Troy Post Office for the acceptance clerk visit.",
      icon: "ri-graduation-cap-line",
    },
    {
      id: "troy-5",
      name: "Rensselaer County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "105 3rd Street, 2nd Floor",
      city: "Troy",
      state: "NY",
      zip: "12180",
      phone: "(518) 270-4080",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Troy — Rensselaer County Government",
      website: "https://www.rensco.com/",
      websiteLabel: "Rensselaer County Clerk",
      notes: "County government passport acceptance facility. Alternative to post office locations. No photo services on-site — bring your own 2x2 photos. Appointments strongly recommended.",
      icon: "ri-government-line",
    },
    {
      id: "troy-6",
      name: "Albany Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "30 Karner Road",
      city: "Albany",
      state: "NY",
      zip: "12288",
      phone: "(518) 452-2270",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Albany — ~10 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest Capital Region passport acceptance facility. More appointment slots and extended hours. Good alternative when Troy facilities are booked during RPI semester transitions.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 3+ hours to New York Passport Agency in Manhattan", fpc: "Most Troy travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Capital Region & RPI Guidance", agency: "Generic — no RPI, ALB airport, Amtrak, or engineering co-op expertise", fpc: "Full RPI/engineering co-op/Capital Region/Amtrak knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "RPI Co-op Acceptance-to-Departure Window Is Razor-Thin",
      description: "RPI engineering co-ops — especially in Germany, Switzerland, and Singapore — often come with 2–3 weeks notice between acceptance and start date. Standard passport processing takes 8–11 weeks. Expedited courier service is the only reliable path for co-op students.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Amtrak-to-JFK Passport Check at the Airport",
      description: "Many Troy residents take Amtrak from the historic Troy Station to JFK for international flights. Your passport is checked at JFK — not at the Troy station. An expired passport discovered after a 3-hour train ride means you are stranded at the airport.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Troy applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Troy-area CVS and Walgreens locations produce photos that fail State Department standards — wrong background shade, improper head size, or shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Schengen 6-Month Rule on Engineering Co-ops",
      description: "RPI students heading to Germany, Switzerland, or other Schengen countries for co-ops often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately for academic travelers.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date or co-op start and complete your secure order. Takes just a few minutes from your home, office, or RPI dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Troy clients ship from home or a local UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 3+ hours to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Troy?", a: "We offer Troy-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays — especially important during RPI co-op acceptance season." },
    { q: "Do I need to visit a Troy office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Troy Post Office, Rensselaer County Clerk, or nearby post offices), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Troy address." },
    { q: "Where can I get a passport acceptance in Troy?", a: "Troy has acceptance facilities at the Main Post Office on Broadway, the Rensselaer County Clerk on 3rd Street, and post offices in Rensselaer, Wynantskill, and Albany. We maintain an updated list of Capital Region facilities with hours, photo availability, and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency in Manhattan requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For Troy residents, that means a 3+ hour drive each way — our courier service eliminates the need for this trip entirely." },
    { q: "What is the best price for expedited passport service in Troy?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can you help RPI students with co-op passports?", a: "Yes. We regularly assist Rensselaer Polytechnic Institute students with expedited passports for international co-ops in Germany, Switzerland, Singapore, and beyond. We understand the compressed 2–3 week acceptance-to-departure timeline and prioritize student applications during peak co-op acceptance season." },
    { q: "What documents do Troy applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Troy-specific checklist." },
    { q: "Can I take Amtrak from Troy to JFK with an expired passport?", a: "No. While you can board the Amtrak at Troy Station without a passport check, your passport will be verified at JFK before your international flight. An expired passport discovered at the airport after a 3-hour train ride means a missed flight with no easy recourse. Always verify passport validity before boarding the train." },
    { q: "Is Troy near a passport agency?", a: "The closest passport agency is the New York Passport Agency in Manhattan — approximately 150 miles (3+ hours) southeast. For Troy residents, our courier channel is the only practical option for expedited processing without a full-day trip." },
    { q: "Can I get a passport photo in Troy?", a: "Yes — CVS, Walgreens, UPS Stores, and the Troy Post Office offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Troy Residents",
    intro: "Troy's unique position as home to RPI — one of the nation's top engineering schools — and a Hudson River city in the Capital Region creates distinct passport timing challenges. Here's what Troy travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "RPI — The Engineering Co-op Passport Engine",
        subtitle: "Rensselaer Polytechnic Institute sends hundreds of students abroad to Germany, Switzerland, and Singapore",
        description: "RPI's renowned engineering co-op program sends students to global technology companies across Europe and Asia. The acceptance-to-departure window is notoriously tight — often just 2–3 weeks from offer to orientation. Many students are first-time passport applicants who have never navigated the DS-11 process. International students at RPI also need passport services — renewing home-country documents while studying in Troy adds complexity that standard services cannot handle.",
        tip: "RPI co-op students should apply for their passport the moment they submit co-op applications — not after acceptance. Having a valid passport ready when the offer arrives eliminates the most stressful variable in the process.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "15 minutes from downtown Troy, Capital Region's primary airport",
        description: "Albany International connects the Capital Region to major U.S. hubs like Chicago, Atlanta, Detroit, and Washington DC. From Troy, ALB is a quick 15-minute drive across the Hudson. Most international travel from Troy involves a domestic connection through these gateways. ALB's manageable size means shorter security lines and easier parking — but limited direct international flights. Troy travelers must have passports ready at ALB check-in, not just at the international gateway.",
        tip: "ALB connections through Chicago O'Hare and Atlanta are the primary international gateways for Troy travelers. Always verify passport validity when booking — your passport is verified at ALB, not just at the international connection.",
      },
      {
        icon: "ri-train-line",
        title: "Troy Amtrak Station — The JFK Connection",
        subtitle: "Empire Service corridor connects Troy to New York Penn Station in 3 hours",
        description: "The historic Troy Amtrak Station on Fulton Street offers a unique travel dynamic: many Troy residents take Amtrak to New York Penn Station and transfer to JFK for international flights. This rail-to-air strategy is popular for families, seniors, and students — but creates a critical passport checkpoint. Travelers board the train in Troy without a passport check but need a valid passport at JFK. An expired passport discovered after a 3-hour train ride and airport transfer leaves travelers stranded at the airport.",
        tip: "If you are taking Amtrak from Troy to JFK for an international flight, verify your passport before you leave home. Once aboard the train, there is no turning back — and a passport issue at JFK means missing your departure with a 3-hour journey back.",
      },
      {
        icon: "ri-building-2-line",
        title: "Capital Region Tech & Engineering Corporate Travel",
        subtitle: "Growing tech corridor generates short-notice international business trips",
        description: "The Capital Region's technology sector — spanning from Troy's waterfront to Albany's nanotech corridor — generates regular international travel for engineers, researchers, and business development professionals. Companies like GlobalFoundries, Regeneron, and GE Power send employees abroad for supplier meetings, technology transfer, and client engagements. These trips often materialize on short notice with 1–2 week booking windows that demand expedited passport processing.",
        tip: "Capital Region tech professionals traveling to semiconductor hubs in Taiwan, Singapore, and Germany need 6-month passport validity. Always check your passport expiration date before accepting an international assignment — the booking window will be too tight to fix it afterward.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Troy & the Hudson River Heritage Travel Corridor",
      description: "Troy has deep Irish and Italian heritage — exactly the kind of community that books multi-generational trips to ancestral hometowns in Ireland and Italy. These family trips often involve first-time passport applicants — grandparents taking grandchildren to see the family village for the first time — creating multiple simultaneous passport applications with tight summer travel deadlines.",
    },
  },
  destinations: {
    title: "Where Troy Travelers Go — And Why Passports Get Urgent",
    intro: "Troy's mix of RPI engineers, Capital Region tech professionals, and deep-rooted heritage communities means passports are needed for destinations spanning engineering hubs, cultural capitals, and ancestral villages.",
    stats: [
      { stat: "35%", label: "of Troy expedited requests are RPI co-op, study abroad, or university-related with 2–3 weeks notice" },
      { stat: "2–3 Weeks", label: "typical RPI co-op acceptance-to-departure window — the tightest academic timeline in the Capital Region" },
      { stat: "May–Aug", label: "peak season when RPI co-op placements, summer heritage travel, and Capital Region vacations collide" },
      { stat: "38 Hours", label: "shortest turnaround for an RPI student departing to a co-op in Stuttgart, Germany" },
    ],
    destinations: [
      { name: "Germany", context: "RPI co-ops at Siemens, Bosch, BMW, and Daimler in Stuttgart, Munich, and Berlin — the most common co-op destination", urgency: "Co-op acceptance 2–3 weeks before start — 6-month validity required for Schengen visa", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Deep Italian-American heritage in Troy and Rensselaer County, family reunions in Sicily and Campania, summer heritage tourism", urgency: "Summer family trips booked months ahead but passports checked at the last minute — multiple generations need simultaneous renewals", icon: "ri-map-pin-2-line" },
      { name: "Switzerland", context: "RPI co-ops at ABB, ETH Zurich research exchanges, engineering internships at Swiss technology firms", urgency: "Fall co-op placements with August-to-September start dates — right when Troy's acceptance facilities are busiest", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "Strong Irish-American heritage in Troy and the Hudson Valley, ancestry trips to Cork, Galway, and Dublin", urgency: "May–August heritage season with multi-generational family groups needing multiple passports simultaneously", icon: "ri-map-pin-2-line" },
      { name: "Singapore", context: "RPI co-ops at semiconductor and technology firms, Capital Region engineering exchange programs", urgency: "6-month passport validity required for work passes — co-op students often discover this requirement after acceptance", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal weekend trips from the Capital Region (3.5 hours), Toronto getaways, Ottawa business connections", urgency: "Weekend trips booked on impulse — passport discovered expired the night before departure", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albany", route: "/albany-ny" },
      { name: "Schenectady", route: "/schenectady" },
      { name: "Saratoga Springs", route: "/saratoga-springs" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Troy", address: "120 Hoosick Street, Troy, NY 12180", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Troy", address: "5 126th Street, Troy, NY 12182", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Troy", address: "10 123rd Street, Troy, NY 12182", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Troy", address: "760 Hoosick Road, Troy, NY 12180", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "FedEx Office — Albany", address: "1440 Central Avenue, Albany, NY 12205", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — East Greenbush", address: "596 Columbia Turnpike, East Greenbush, NY 12061", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Rensselaer", address: "305 Columbia Street, Rensselaer, NY 12144", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Latham", address: "873 New Loudon Road, Latham, NY 12110", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Troy",
      address: "501 Columbia Turnpike, Troy, NY 12180",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended. Also handles Enhanced Driver's Licenses for border crossings.",
      featured: true,
    },
    {
      name: "NYS DMV — Rensselaer",
      address: "50 Broadway, Rensselaer, NY 12144",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving Rensselaer and east-of-the-river residents. REAL ID available. Often less crowded than Troy during peak periods.",
      featured: false,
    },
    {
      name: "NYS DMV — East Greenbush",
      address: "625 Columbia Turnpike, East Greenbush, NY 12061",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving East Greenbush, Schodack, and southern Rensselaer County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 15 miles from downtown Troy",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with flights to major U.S. hubs. Primary international gateway for Troy travelers — 15 minutes across the Hudson River.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SCH",
      name: "Schenectady County Airport",
      distance: "About 25 miles from Troy",
      address: "70 Airport Road, Scotia, NY 12302",
      note: "General aviation airport. Primarily for private flights and charter services. No commercial passenger service.",
      flightUrl: "https://www.schenectadyairport.com/",
      flightLabel: "Schenectady Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records in Albany. Rensselaer County residents can also contact the Rensselaer County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Rensselaer County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Rensselaer County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.rensco.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Rensselaer County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default troyConfig;